import { calculateDateProgress } from '../../common/formatDateText';
import './DateRangeProgressBar.css';

/**
 * Barra de progreso temporal entre dos fechas (mismo cálculo que suscripción en estudiantes).
 * @param {string|Date|undefined|null} startDate
 * @param {string|Date|undefined|null} endDate
 * @param {boolean} [allowMissingStart=false] — Si true, se muestra con solo `endDate` (ej. suscripción).
 * @param {(progress: number) => string} [footerText] — Texto bajo la barra; por defecto "{n}% completado".
 * @param {string} [label] — Texto de la barra; por defecto "{n}% completado".
 */
export function DateRangeProgressBar({
	startDate,
	endDate,
	allowMissingStart = false,
	footerText,
	label,
}) {
	const visible = allowMissingStart ? Boolean(endDate) : Boolean(startDate && endDate);
	if (!visible) {
		return null;
	}

	const progress = Math.min(calculateDateProgress(startDate, endDate), 100);
	const footer =
		typeof footerText === 'function' ? footerText(progress) : `${label} ${progress}%`;

	return (
		<div className="w-[200px]">
			<div className="w-full bg-gray-100 rounded-lg h-4 overflow-hidden relative border border-gray-300">
				<div
					className={`h-6 transition-all duration-500 ease-out relative ${progress < 40
							? 'bg-gradient-to-r from-green-400 via-green-500 to-green-600'
							: progress < 70
								? 'bg-gradient-to-r from-yellow-400 via-yellow-500 to-amber-500'
								: 'bg-gradient-to-r from-orange-500 via-red-500 to-red-600'
						}`}
					style={{ width: `${progress}%` }}
				>
					<div
						className="date-range-progress-bar__stripes absolute inset-0 opacity-20"
						style={{
							backgroundImage:
								'repeating-linear-gradient(45deg, transparent, transparent 10px, rgba(255,255,255,.5) 10px, rgba(255,255,255,.5) 20px)',
						}}
					/>
				</div>
			</div>
			<div className="flex justify-between items-center mt-1">
				<span className="text-xs font-bold text-gray-700">{footer}</span>
			</div>
		</div>
	);
}

export function DateRangeProgressBarCell({
	startDate,
	endDate,
	allowMissingStart,
	footerText,
	label,
}) {
	return (
		<div className="w-full flex justify-center items-center">
			<DateRangeProgressBar
				startDate={startDate}
				endDate={endDate}
				allowMissingStart={allowMissingStart}
				footerText={footerText}
				label={label}
			/>
		</div>
	);
}
